import React from 'react';

const FinancialDashboard: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Financial Dashboard</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Financial dashboard features coming soon...</p>
      </div>
    </div>
  );
};

export default FinancialDashboard;
